import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import localOriginCharges from "../../../Services/localOriginCharges";
import locationServices from "../../../Services/locationServices";
import Loader from "../../../Components/Loader";
import SimpleReactValidator from "simple-react-validator";

export const AddCrossBorderOriginCharge = () => {
  const [, setForceUpdate] = useState("");
  const Validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    })
  );

  const [countryList, setCountryList] = useState([]);
  const [originCountryValue, setCountryValue] = useState("");
   const [handlingIn, setHandlingIn] = useState();
   const [handlingOut, setHandlingOut] = useState();
  const [adminFee, setAdminFee] = useState()
  const [loader, setLoader] = useState(false)

  const initial = {
    min: "",
    max: "",
    price: "",
    country: [
      {
        country_id: "",
        price: "",
      },
    ],
  };

  const [originPriceList, setOriginPriceList] = useState([initial]);
  // const [countryPriceList, setCountryPriceList] = useState([]);

  const history = useHistory();


  const getCountryList = () => {
    let param = {
      limit: 250,
      page: 1,
    };
    locationServices.getCountry(param).then((res) => {
      if (res.status) {
        let arry = [];
        // eslint-disable-next-line
        res.data.map((list) => {
          arry.push({ value: list._id, label: list.country_name, data: list });
        });
        // eslint-disable-next-line
        let activeCountry = arry.filter(
          // eslint-disable-next-line
          (item) => {
            if (item.data.country_currency === "AED") {
              return item
            }
          }
        )
        setCountryValue({ value: activeCountry[0].value, label: activeCountry[0].label })
        setCountryList(arry);
      } else {
        toast.error(res.message);
      }
    });
  };



  useEffect(() => {
    getCountryList();
  }, []);

  const onSelect = (e) => {
    setCountryValue(e);
  };

  const onSelectCountry = (e, key, type) => {
    // setCountriValue(e);
    let selectarry = [...originPriceList]
    // eslint-disable-next-line
    selectarry.map((item, id) => {
      // eslint-disable-next-line
      item.country.map((val, idx) => {
        if (key === idx) {
          if (type === id) {
            val.country_id = e.value
          }
        }
      })
    })
  };

  const addOriginhandler = () => {
    let addArry = [...originPriceList];
    addArry.push(initial);
    setOriginPriceList(addArry);
  };

  const originRemoveHandler = (key) => {
    let removeArry = [...originPriceList];
    removeArry.splice(key, 1);
    setOriginPriceList(removeArry);
  };

  const addCountryHandler = (keys) => {
    let countryArry = [...originPriceList];
    // eslint-disable-next-line
    countryArry.map((val, id) => {
      if (keys === id) {
        val.country.push({
          country_id: "",
          price: "",
        });
      }
    });
    setOriginPriceList(countryArry);
  };

  const removeCountryHandler = (keys) => {
    let deleteArray = [...originPriceList];
    // eslint-disable-next-line
    deleteArray.map((val, id) => {
      if (keys === id) {
        val.country.splice(id, 1);
      }
    });
    setOriginPriceList(deleteArray);
  };

  const arrayHandler = (e, key) => {
    const { name, value } = e.target;
    let originArry = [...originPriceList];
    // eslint-disable-next-line
    originArry.map((item, id) => {
      for (const idx in item) {
        if (Object.hasOwnProperty.call(item, idx)) {
          if (key === id) {
            if (idx === name) {
              item[idx] = value;
            }
          }
        }
      }
    });
    setOriginPriceList(originArry);
  };

  const contryArryHandler = (e, ind, keys) => {
    const { name, value } = e.target;

    let contryarry = [...originPriceList]
    // eslint-disable-next-line
    contryarry.map((item, key) => {
      // eslint-disable-next-line
      item && item.country.map((list, i) => {
        if (keys === key) {
          if (ind === i) {
            if (name === "price") {
              list.price = value;
            }
          }
        }
      })
    })

    setOriginPriceList(contryarry);

  }

  const onSubmitHandler = (e) => {
    e.preventDefault();

    let array = [...originPriceList];
    // eslint-disable-next-line
    array.map((val, i) => {
      // eslint-disable-next-line
      val.country.map((list, ind) => {
        if (val.country[ind].price <= 0) {
          return val.country = []
        }
      })
    })

    let postData = {
      country: originCountryValue && originCountryValue.value,
      be_fee:0,
      admin_fee: adminFee,
      handling_in_out: handlingIn?handlingIn:0,
      min_handling_in_out: handlingOut?handlingOut:0,
      origin_price: array
    };

    let validate = Validator.current.allValid();
    if (validate) {
      // console.log("postData", postData)
      setLoader(true)
      localOriginCharges.addLocalOriginChargeCrossBorder(postData).then((res) => {
        if (res.status) {
          history.push("/cross-border-origin-charge-list");
          setLoader(false)
        } else {
          toast.error(res.message);
          setLoader(false)
        }
      });
    } else {
      Validator.current.showMessages();
    }
  };

  // console.log(originCountryValue.value)

  return (
    <>
      {/* /// DESIGN FOR NEW DATA */}

      <div className="row justify-content-center">
        <div className="col-lg-8">
          <div className="card">
            <div className="card-body">
              <form
                className="control-form"
                onSubmit={(e) => onSubmitHandler(e)}
              >
                <div className="mb-3 row">
                  <div className="col-6">
                    <label className="form-label"> Country </label>
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          boxShadow: "0 0 0 0px #f46a6a",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      name="country"
                      value={originCountryValue}
                      onChange={(e) => onSelect(e)}
                      options={countryList}
                      isDisabled
                    />
                    {Validator.current.message(
                      "Country",
                      originCountryValue,
                      "required",
                      { className: "text-danger" }
                    )}
                  </div>

                  <div className="col-6">
                    <label className="form-label"> Admin Fee </label>
                    <input
                      type="number"
                      min="0"
                      className="form-control"
                      name="admin_fee"
                      placeholder="Admin Fee"
                      onChange={(e) => setAdminFee(e.target.value)}
                    />
                    {Validator.current.message(
                      "Admin Fee",
                      adminFee,
                      "required",
                      { className: "text-danger" }
                    )}
                  </div>
                  <div className="col-6">
                    <label className="form-label"> Handling In/Out </label>
                    <input
                      type="number"
                      min="0"
                      className="form-control"
                      name="handling_in_out"
                      placeholder="handling In/Out"
                      onChange={(e) => setHandlingIn(e.target.value)}
                    />
                    {Validator.current.message(
                      "Handling in/out",
                      handlingIn,
                      "required",
                      { className: "text-danger" }
                    )}
                  </div>

                  <div className="col-6">
                    <label className="form-label"> Min Handling In/Out </label>
                    <input
                      type="number"
                      min="0"
                      className="form-control"
                      name="min_handling_in_out"
                      placeholder="min handling In/Out"
                      onChange={(e) => setHandlingOut(e.target.value)}
                    />
                    {Validator.current.message(
                      "Min Handling in/out",
                      handlingOut,
                      "required",
                      { className: "text-danger" }
                    )}
                  </div>

                </div>
                <hr />
                <div className="row py-2">
                  <div>
                    <h6>
                      Value Based Charges
                    </h6>
                    {originPriceList &&
                      originPriceList.map((item, key) => {
                        return (
                          <>
                            <div className="row">
                              <div className="col-3">
                                <label className="form-label"> Min Charges </label>
                                <input
                                  type="number"
                                  min="0"
                                  name="min"
                                  className="form-control"
                                  value={item.min}
                                  placeholder="min"
                                  onChange={(e) => arrayHandler(e, key)}
                                />
                                {Validator.current.message(
                                  "Min",
                                  item.min,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>

                              <div className="col-3">
                                <label className="form-label"> Max Charges </label>
                                <input
                                  type="number"
                                  min="0"
                                  name="max"
                                  className="form-control"
                                  value={item.max}
                                  placeholder="max"
                                  onChange={(e) => arrayHandler(e, key)}
                                />
                                {Validator.current.message(
                                  "Max",
                                  item.max,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>

                              <div className="col-4">
                                <label className="form-label"> Price </label>
                                <input
                                  type="number"
                                  min="0"
                                  name="price"
                                  className="form-control"
                                  value={item.price}
                                  placeholder="enter price"
                                  onChange={(e) => arrayHandler(e, key)}
                                />
                                {Validator.current.message(
                                  "Price",
                                  item.price,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>

                              <div className="col-2">
                                {/* {originPriceList.length >= 2 && ( */}
                                <button
                                  className="btn btn-sm btn-secondary mt-4"
                                  type="button"
                                  onClick={() => originRemoveHandler(key)}
                                >
                                  {" "}
                                  - Remove
                                </button>
                                {/* )} */}
                              </div>
                            </div>

                            <div className="border-custom mt-3">
                              <h6>GCC country</h6>
                              {item &&
                                item &&
                                item.country.map((list, ind) => {
                                  return (
                                    <>
                                      <div>
                                        <div className="mb-3 row justify-content-end">
                                          <div className="col-5">
                                            <label className="form-label">
                                              Select Country{" "}
                                            </label>
                                            <Select
                                              styles={{
                                                valueContainer: (provided) => ({
                                                  ...provided,
                                                  height: "calc(2.15rem + 2px)",
                                                  overflowY: "visible",
                                                }),
                                                control: (provider) => ({
                                                  ...provider,

                                                  boxShadow:
                                                    "0 0 0 0px #f46a6a",
                                                }),
                                                placeholder: (provider) => ({
                                                  ...provider,
                                                  color: "#a0b0ca",
                                                }),
                                              }}
                                              value={list.country}
                                              onChange={(e) =>
                                                onSelectCountry(e, ind, key)
                                              }
                                              options={countryList}
                                            />
                                            {/* {Validator.current.message('Price', list.price, 'required', {className: "text-danger"})} */}
                                          </div>
                                          <div className="col-5">
                                            <label className="form-label">
                                              {" "}
                                              Price{" "}
                                            </label>
                                            <input
                                              type="number"
                                              min="0"
                                              className="form-control"
                                              placeholder="enter price"
                                              name="price"
                                              value={list.price}
                                              onChange={(e) => contryArryHandler(e, ind, key)}
                                            />
                                          </div>

                                          <div className="col-2">
                                            <button
                                              className="btn btn-sm btn-secondary me-2 mt-4"
                                              type="button"
                                              onClick={() =>
                                                removeCountryHandler(key)
                                              }
                                            >
                                              {" "}
                                              - Remove
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  );
                                })}
                              <div className="d-flex justify-content-end">
                                <button
                                  className="btn btn-sm btn-info"
                                  type="button"
                                  onClick={() => addCountryHandler(key)}
                                >
                                  {" "}
                                  + Add GCC
                                </button>
                              </div>
                            </div>

                          </>
                        );
                      })}

                    {/* {originPriceList &&
                      originPriceList.map((item, key) => {
                        console.log(item.country)
                        return (
                          
                         );
                      })} */}
                  </div>
                </div>

                <div className="d-flex justify-content-start">
                  <button
                    className="btn btn-sm btn-info"
                    type="button"
                    onClick={() => addOriginhandler()}
                  >
                    {" "}
                    + Add More
                  </button>
                </div>

                <div className="mt-3 d-flex justify-content-between">
                  <button
                    className="btn btn-danger w-sm waves-effect waves-light"
                    type="button"
                    onClick={() => history.goBack()}
                  >
                    Back
                  </button>
                  <button
                    className="btn btn-primary w-sm waves-effect waves-light"
                    type="submit"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <Loader isShow={loader} />
      </div>
    </>
  );
};
